//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQDeniedPage from "@/components/Generics/AQDeniedPage/AQDeniedPage.vue";
import { validBrowserMessage, validPlatformMessage } from "@/assets/js/appFunc";

export default {
    name: "AQBrowserNotSupported",
    components: {
        AQDeniedPage
    },
    props: {
        validBrowser: { type: Boolean, required: true },
        validPlatform: { type: Boolean, required: true }
    },
    computed: {
        heading() {
            return this.validPlatform ? this.$t("exportReports.browserNotSupported") : this.$t("exportReports.platformNotSupported");
        },
        title() {
            return this.validPlatform ? this.$t("exportReports.usedBrowsers") : this.$t("exportReports.usedPlatforms");
        },
        subTitle() {
            return this.validPlatform ? validBrowserMessage() : validPlatformMessage();
        }
    }
};
